import { defineMessages } from 'react-intl';

export default defineMessages({
  loginPromptLink: {
    id: 'pricing.loginPromptLink ',
    defaultMessage: 'Log in',
  },
  loginPrompt: {
    id: 'components.ProductUpgradeMessage.loginPrompt',
    defaultMessage:
      'Already own NI products? {loginPromptLink} to see if you qualify for cheaper pricing.',
  },
  userUnqualified: {
    id: 'components.ProductUpgradeMessage.userUnqualified',
    defaultMessage:
      'You don’t have any previous products eligible for updates/upgrades on this account.',
  },
  loginMessage: {
    id: 'components.ProductUpgradeMessage.loginMessage',
    defaultMessage: '{LoginLink} to see if you qualify for a cheaper version.',
  },
  qualifiesForVariant: {
    id: 'components.ProductUpgradeMessage.qualifiesForVariant',
    defaultMessage:
      'As an owner of {baseProduct} you qualify to install and activate this version.',
  },
  qualifiesForUpgrade: {
    id: 'components.ProductUpgradeMessage.qualifiesForUpgrade',
    defaultMessage:
      'As an owner of {baseProduct} you qualify for the {UpgradeButton}.',
  },
  noQualifyingProducts: {
    id: 'components.ProductUpgradeMessage.noQualifyingProducts',
    defaultMessage:
      'None of the qualifying products are registered to your account "{customerEmail}".',
  },
  UpgradeButton: {
    id: 'components.ProductUpgradeMessage.UpgradeButton',
    defaultMessage: 'Upgrade',
  },
  ownershipWarning: {
    id: 'components.ProductUpgradeMessage.ownershipWarning',
    defaultMessage:
      "You won't be able to install and activate this version unless you own one of the required products listed above!",
  },
});
